import { CircularProgress, Grid2 as Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ProductDetailRow } from "../ProductDetailRow";
import { useProductDetails } from "../../hooks/useProductDetails.ts";
interface Props {
  productId: string;
}

export const ProductTab: React.FC<Props> = ({ productId }) => {
  const { t } = useTranslation();
  const { data: product, isLoading, isError } = useProductDetails(productId);

  if (isLoading) {
    return <CircularProgress aria-label={t("product.loading")} />;
  }

  if (isError || !product) {
    return <Typography p={2}>{t("product.error")}</Typography>;
  }

  return (
    <Grid container spacing={2} p={0}>
      <Grid size={{ xs: 12, md: 4 }}>
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ 
            mb: 1.5,
            fontSize: "1rem",
            fontWeight: 600,
          }}
        >
          {t("product.detailDrawer.section.details")}
        </Typography>
        <Grid container spacing={1}>
          <ProductDetailRow
            label={t("product.detailDrawer.code")}
            value={product?.code}
          />
          <ProductDetailRow
            label={t("product.detailDrawer.name")}
            value={product?.name}
          />
          <ProductDetailRow
            label={t("product.detailDrawer.application")}
            value={product?.toepassing}
          />
          <ProductDetailRow
            label={t("product.detailDrawer.articleGroup")}
            value={product?.artikelgroep}
          />
        </Grid>
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ 
            mb: 1.5,
            fontSize: "1rem",
            fontWeight: 600,
          }}
        >
          {t("product.detailDrawer.section.data")}
        </Typography>
        <Grid container spacing={1}>
          <ProductDetailRow
            label={t("product.detailDrawer.startDate")}
            value={product?.createdAt}
            labelWidth={6}
            valueWidth={6}
          />
          <ProductDetailRow
            label={t("product.detailDrawer.endDate")}
            value={product?.experationDate}
            labelWidth={6}
            valueWidth={6}
          />
        </Grid>
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ 
            mb: 1.5,
            fontSize: "1rem",
            fontWeight: 600,
          }}
        >
          {t("product.detailDrawer.section.mutation")}
        </Typography>
        <Grid container spacing={1}>
          <ProductDetailRow
            label={t("product.detailDrawer.mutationUser")}
            value={product?.modifiedBy}
            labelWidth={6}
            valueWidth={6}
          />
          <ProductDetailRow
            label={t("product.detailDrawer.mutationDate")}
            value={product?.mutationDate}
            labelWidth={6}
            valueWidth={6}
          />
          <ProductDetailRow
            label={t("product.detailDrawer.vbnVersionDate")}
            value={product?.vbnDate}
            labelWidth={6}
            valueWidth={6}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
